import React from 'react';
import { ArrowRight, CheckCircle, Shield, Clock } from 'lucide-react';
import { Button } from './ui/button';

export const HeroSection = ({ onBookAppointment }) => {
  const scrollToServices = () => {
    const el = document.getElementById('services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-gradient-to-br from-slate-50 via-white to-emerald-50 pt-8 pb-16 overflow-hidden">
      <div className="absolute inset-0 opacity-5 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Your Business Deserves CFO-Level Thinking —
            <span className="text-emerald-600"> Without the Full-Time Cost</span>
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed max-w-2xl mx-auto">
            We help Indian SMEs, startups and family businesses with financial strategy, MIS reporting, cash flow planning, GST compliance and fundraising support — on a flexible retainer.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8">
            <Button
              onClick={onBookAppointment}
              size="lg"
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 sm:px-8 py-6 sm:py-7 text-base sm:text-lg rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 group"
              data-testid="hero-cta-primary"
            >
              Book a Free 30-Min Consultation
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={scrollToServices}
              variant="outline"
              size="lg"
              className="border-2 border-gray-300 text-gray-700 px-6 sm:px-8 py-3 sm:py-3.5 text-base sm:text-lg rounded-full hover:bg-gray-50 h-[52px] sm:h-[60px]"
              data-testid="hero-cta-secondary"
            >
              See Our Services
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm sm:text-base text-gray-700">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
              <span>Serving SMEs & Startups across India</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
              <span>Flexible Monthly Retainers</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />
              <span>CA-Backed Financial Expertise</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
